import { render, staticRenderFns } from "./addopenid.vue?vue&type=template&id=2f8357f9&scoped=true"
import script from "./addopenid.vue?vue&type=script&lang=js"
export * from "./addopenid.vue?vue&type=script&lang=js"
import style0 from "./addopenid.vue?vue&type=style&index=0&id=2f8357f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8357f9",
  null
  
)

export default component.exports